// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ujjN2","version":"footer_version__BdY5P"};